import { conversionConfig } from '@api/auth/config';
import type { ConversionVendor, ConversionEvent, VendorTracker } from '../useConversionTracker';
import { resolveVendorEventName } from './conversionEventMap';

interface VendorTrackerOptions {
  vendor: ConversionVendor;
  fire: (vendorEventName: string, callback?: () => void) => void;
}

export function createVendorTracker({ vendor, fire }: VendorTrackerOptions): VendorTracker {
  const prefix = `[${vendor.charAt(0).toUpperCase()}${vendor.slice(1)}ConversionTracker]`;

  return {
    track(event: ConversionEvent) {
      const vendorEventName = resolveVendorEventName(event.event, vendor);
      if (!vendorEventName) {
        console.warn(`${prefix} No ${vendor} mapping for event "${event.event}" — skipping`);
        event.callback?.();
        return;
      }

      if (process.env.NODE_ENV === 'development' || !conversionConfig.active) {
        console.log(`${prefix} dry-run`, { vendorEventName });
        event.callback?.();
        return;
      }

      fire(vendorEventName, event.callback);
    },
  };
}
